import { LitElement, html, svg } from 'lit';

export class IconStairs24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Trappetrinn med diagonal pil opp</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M23.25 12.751 12.777 23.25M17.25 12.751h6v5.894M.75 23.25v-6h6v-6h6v-6h6V.89"></path></svg>`; }
}
if (!customElements.get('f-icon-stairs24', IconStairs24)) {
  customElements.define('f-icon-stairs24', IconStairs24);
}